import { Pressable, Text, View } from 'react-native';
import { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../constants/Colors';
import TemplateIcon30 from '../30pxIcons/TemplateIcon30';
import RightArrow24 from '../24pxIcons/RightArrow24';
import EllipsisIconVertical from '../EllipsisIconVertical';
import updateAsset from '../../requests/Assets/UpdateAsset';
import SensorIcon from '../24pxIcons/SensorIcon';
import { logEvent } from '../LogEvent';
import { SOMETHING_WENT_WRONG } from '../../constants/AlertMessages';
import { AppScreen } from '../../navigation/LinkingConfiguration';
import { SelectedTicketState, updateSelectedTicket } from '../../redux/selectedTicketSlice';
import { Ticket } from '../../constants/Types';

interface Props {
  index: number;
  asset: any;
  setMovingItem: any;
  move: any;
  editPosition: any;
  showAlert: any;
  removeAsset: any;
  isSensor: any;
  editMode: boolean;
  hideDrawer: any;
  drawerOpen: boolean;
  assetContextIndex?: string;
  // eslint-disable-next-line no-unused-vars
  setAssetContextIndex: (id: any) => void;
  focusedAssetId: string;
  sectionExpanded: boolean;
  floorId: string;
}

const AssetRow = (props: Props) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const selectedTicketDetails: SelectedTicketState = useSelector((state:
    { selectedTicket: SelectedTicketState }) => state.selectedTicket);
  const selectedTicket: Ticket | undefined = selectedTicketDetails.ticket;

  useEffect(() => {
    if (!props.drawerOpen || !props.editMode || !props.sectionExpanded) {
      props.setAssetContextIndex('');
    }
  }, [props.drawerOpen, props.editMode, props.sectionExpanded]);

  function deletePosition() {
    const assetToUpdate = props.asset;
    delete assetToUpdate.GeoX;
    delete assetToUpdate.GeoY;
    assetToUpdate.hasXY = false;
    assetToUpdate.customFields = assetToUpdate.customFields.filter(
      (field) => field.name !== 'GeoX' && field.name !== 'GeoY',
    );
    updateAsset({
      assetId: assetToUpdate.id,
      name: assetToUpdate.name,
      description: assetToUpdate.description,
      manufacturer: assetToUpdate.manufacturer,
      model: assetToUpdate.model,
      serial: assetToUpdate.serial,
      locationId: assetToUpdate.locationId,
      customFields: assetToUpdate.customFields,
      labels: assetToUpdate.labels,
    }).then((response) => {
      const success = response && !response.isError;
      if (!success) {
        props.showAlert(SOMETHING_WENT_WRONG, true);
      } else {
        if (selectedTicket && selectedTicket.assetId === props.asset.id) {
          const updatedTicket = {
            ...selectedTicket,
            onMap: false,
            pinned: true,
          };
          dispatch(updateSelectedTicket(updatedTicket));
        }
        props.removeAsset();
      }
    });
  }

  return (
    <View
      style={{
        borderWidth: 1,
        borderColor: Colors.light.hereworksBlue100,
        borderRadius: 8,
        paddingLeft: 10,
        marginHorizontal: 16,
        alignSelf: 'stretch',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
        zIndex: props.index * -1,
        backgroundColor: props.focusedAssetId === props.asset.id
          ? Colors.light.hereworksBlue50 : '#fff',
      }}
      key={props.index}
      testID={`asset#${props.index + 1}`}
    >
      {!props.isSensor && <TemplateIcon30 fill={props.asset.GeoX > 0 || props.asset.GeoY > 0 ? '#B6B9BC' : undefined} />}
      {props.isSensor && <SensorIcon fill={props.asset.GeoX > 0 || props.asset.GeoY > 0 ? '#B6B9BC' : Colors.light.hereworksDarkBlue} />}
      <View
        style={{
          flex: 1,
          paddingVertical: 12,
          borderRightWidth: 1,
          marginLeft: 8,
          borderColor: Colors.light.hereworksBlue100,
        }}
      >
        <Text
          style={{
            fontFamily: 'Poppins_500Medium',
            fontSize: 14,
            color: Colors.light.hereworksBlack600,
            lineHeight: 21,
          }}
          selectable
        >
          {props.asset.name}
        </Text>
        <Text
          style={{
            fontFamily: 'Poppins_500Medium',
            fontSize: 12,
            color: Colors.light.hereworksBlack400,
          }}
        >
          {props.asset.tempateName}
        </Text>
      </View>
      {props.editMode // allow edit on mobile:  || isMobile
        && (!(props.asset.GeoX > 0 || props.asset.GeoY > 0) ? (
          <Pressable
            style={(state) => [
              {
                paddingHorizontal: 10,
                opacity: state.hovered ? 0.5 : 1,
              },
            ]}
            onPress={props.move}
          >
            <RightArrow24 />
          </Pressable>
        ) : (
          <Pressable
            style={(state) => [
              {
                paddingHorizontal: 10,
                opacity: state.hovered ? 0.5 : 1,
              },
            ]}
            onPress={() => {
              if (props.asset.id === props.assetContextIndex) props.setAssetContextIndex('');
              else props.setAssetContextIndex(props.asset.id);
            }}
          >
            <EllipsisIconVertical />
          </Pressable>
        ))}
      {!props.editMode
        && (
          <Pressable
            style={(state) => [
              {
                paddingHorizontal: 10,
                opacity: state.hovered ? 0.5 : 1,
              },
            ]}
            onPress={() => {
              if (props.asset.id === props.assetContextIndex) props.setAssetContextIndex('');
              else props.setAssetContextIndex(props.asset.id);
            }}
          >
            <EllipsisIconVertical />
          </Pressable>
        )}
      {props.assetContextIndex === props.asset.id && (
        <View
          style={{
            position: 'absolute',
            backgroundColor: '#fff',
            right: 0,
            top: 50,
            borderRadius: 8,
            borderColor: Colors.light.hereworksBlue300,
            borderWidth: 1,
            overflow: 'hidden',
          }}
        >
          {props.editMode ? <View>
            <Pressable
              style={(state) => [
                {
                  opacity: state.hovered ? 0.5 : 1,
                  backgroundColor: state.hovered ? Colors.light.hereworksBlue200 : '#fff',
                  padding: 8,
                  flex: 1,
                },
              ]}
              onPress={() => {
                props.setAssetContextIndex('');
                props.editPosition();
              }}
            >
              <Text
                style={{
                  fontFamily: 'Poppins_500Medium',
                  fontSize: 14,
                  color: Colors.light.hereworksBlack600,
                }}
              >
                Edit position
              </Text>
            </Pressable>
            <Pressable
              style={(state) => [
                {
                  opacity: state.hovered ? 0.5 : 1,
                  backgroundColor: state.hovered ? Colors.light.hereworksBlue200 : '#fff',
                  padding: 8,
                },
              ]}
              onPress={() => {
                props.setAssetContextIndex('');
                deletePosition();
              }}
            >
              <Text
                style={{
                  fontFamily: 'Poppins_500Medium',
                  fontSize: 14,
                  color: Colors.light.hereworksBlack600,
                }}
              >
                Delete position
              </Text>
            </Pressable>
          </View> : <View>
            <Pressable
              style={(state) => [
                {
                  opacity: state.hovered ? 0.5 : 1,
                  backgroundColor: state.hovered ? Colors.light.hereworksBlue200 : '#fff',
                  padding: 8,
                },
              ]}
              onPress={() => {
                logEvent('AssetRow', 'arrow');
                navigation.navigate(AppScreen.ASSET_MANAGEMENT as any, { assetId: props.asset.id });
                // TODO: remove following block after testing
                // navigation.navigate(AppScreen.TEMPLATE_MANAGEMENT as any, {
                //   assetId: props.asset.id ?? '-',
                //   templateId: props.asset.templateId,
                // });
                props.hideDrawer();
              }}
              testID='map-navigate-to-asset-btn'
            >
              <Text
                style={{
                  fontFamily: 'Poppins_500Medium',
                  fontSize: 14,
                  color: Colors.light.hereworksBlack600,
                }}
              >
                Go to asset
              </Text>
            </Pressable>
            {props.isSensor && <Pressable
              style={(state) => [
                {
                  opacity: state.hovered ? 0.5 : 1,
                  backgroundColor: state.hovered ? Colors.light.hereworksBlue200 : '#fff',
                  padding: 8,
                },
              ]}
              onPress={() => {
                logEvent('AssetRow', 'arrow');
                navigation.navigate(AppScreen.INTERNAL_ENVIRONMENT as any, {
                  assetId: props.asset.id ?? '',
                  sensorName: props.asset.name,
                  floorId: props.floorId,
                  areaId: props.asset.locationId,
                  templateId: props.asset.templateId,
                });
                props.hideDrawer();
              }}
              testID='map-navigate-to-insights-btn'
            >
              <Text
                style={{
                  fontFamily: 'Poppins_500Medium',
                  fontSize: 14,
                  color: Colors.light.hereworksBlack600,
                }}
              >
                Go to Insights
              </Text>
            </Pressable>}
          </View>}
        </View>
      )}
    </View>
  );
};

export default AssetRow;
